import LineCheckCircleIcon from 'LuxKit/Icons/line/LineCheckCircleIcon'
import StatusLabel from 'LuxKit/Label/StatusLabel'
import React from 'react'
import { useIntl } from 'react-intl'

interface Props {
  name: string
}

function MultiCartBookedByLabel({ name }: Props) {
  const intl = useIntl()

  return <StatusLabel variant="confirmation" startIcon={<LineCheckCircleIcon />}>
    {intl.formatMessage(
      {
        id: 'ygw+QcZbQH',
        defaultMessage: 'Booked by {name}',
        description: 'Label indicating which user booked the cart item in the shopping cart',
      },
      { name },
    )}
  </StatusLabel>
}

export default MultiCartBookedByLabel
